import { AppDispatch } from '../../../store';
import { getEmployeeDataAction } from '../../../store/actionCreators/employeeActionCreators';
import { CLEAR_TEXT, SET_SELECTABLES } from '../../../store/actions';
import { clearedTimeLog } from '../../../constants/cleared-objects';
import { Msg } from '../../../store/actions';

interface ResetTimeTrackingParams {
  dispatch: AppDispatch;
  setHandleValues: React.Dispatch<Msg>;
}

export const resetTimeTracking = ({
  dispatch,
  setHandleValues,
}: ResetTimeTrackingParams) => {
  dispatch(
    getEmployeeDataAction({
      projectDTOList: [],
      lastUsedProject: {
        eptId: undefined,
        nameProject: undefined,
        nameTask: undefined,
        duration: {
          hours: undefined,
          minutes: undefined,
        },
      },
    }),
  );

  setHandleValues(CLEAR_TEXT({ payload: clearedTimeLog }));

  setHandleValues(
    SET_SELECTABLES({
      payload: {
        projectName: '',
        projectId: '',
        taskId: '',
        taskName: '',
        currentHour: '',
        currentMinute: '',
      },
    }),
  );
};
